// resources/js/admin/pages/module-pages/pages/NewPagePage.tsx

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageFormData } from "../../../types/features/Page";
import PageForm from "../../../components/shared/pages/PageForm";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import { useProduct } from "../../../hooks/core/useProduct";
import usePages from "../../../hooks/features/pages/usePages";

export default function NewPagePage() {
    const navigate = useNavigate();
    const { selectedProduct } = useProduct();
    const { createPage } = usePages(selectedProduct || "izi-call");
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSubmit = async (data: PageFormData): Promise<any> => {
        setIsLoading(true);
        try {
            console.log(data)
            const page = await createPage(data);
            if (page) {
                setIsSuccess(true);
                alertSuccess("Page créée avec succès");
               // navigate("/admin/pages");
                return page;
            } else {
                alertError("Erreur lors de la création de la page");
                return null;
            }
        } catch (error) {
            alertError("Erreur lors de la création de la page");
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <PageLayout title="Nouvelle page" className="p-6 max-w-4xl mx-auto">
            <PageContainer>
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">Nouvelle page</h1>
                    <p className="text-gray-500 mt-1">Créez une nouvelle page pour le site</p>
                </div>
                <PageForm
                    siteSlug={selectedProduct || "izi-call"}
                    isSuccess={isSuccess}
                    onSubmit={handleSubmit}
                    isLoading={isLoading}
                />
            </PageContainer>
        </PageLayout>
    );
}